import { render, staticRenderFns } from "./IconPicker.vue?vue&type=template&id=b9000486&scoped=true&"
import script from "./IconPicker.vue?vue&type=script&lang=js&"
export * from "./IconPicker.vue?vue&type=script&lang=js&"
import style0 from "./IconPicker.vue?vue&type=style&index=0&id=b9000486&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9000486",
  null
  
)

export default component.exports